import { UserVarKey } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

export class UserVarsAPI {
  static async getAllVarsForUser(orgId: number, userId: number) {
    return APIService.Server.get<{ [key in UserVarKey]?: string }>(`/user-vars/org/${orgId}/user/${userId}`);
  }
  static async getUserVars(orgId: number, userId: number, keys: UserVarKey[]) {
    return APIService.Server.get<{ [key in UserVarKey]?: string }>(`/user-vars/org/${orgId}/user/${userId}/vars`, { keys });
  }
  static async saveUserVar(orgId: number, userId: number, key: UserVarKey, value: string) {
    return APIService.Server.put<boolean>(`/user-vars/org/${orgId}/user/${userId}/vars`, { [key]: value });
  }
  static async saveUserVars(orgId: number, userId: number, body: Partial<{ [key in UserVarKey]: any }>) {
    return APIService.Server.put<boolean>(`/user-vars/org/${orgId}/user/${userId}/vars`, body);
  }
  static async deleteUserVar(orgId: number, userId: number, key: UserVarKey) {
    return APIService.Server.delete<boolean>(`/user-vars/org/${orgId}/user/${userId}/var/${key}`);
  }
  static async deleteUserVars(orgId: number, userIds: number[], keys: UserVarKey[]) {
    return APIService.Server.delete<boolean>(`/user-vars/org/${orgId}/vars`, { userIds, keys });
  }
}
